import { connect } from "react-redux";
import { ApproveUsersComponent } from "../../components/ManageUsers/ApproveUsers";

const mapState = ({ auth: { user } }) => {
  return {
    user: user,
  };
};

export default connect(mapState, {})(ApproveUsersComponent);
